/*
    Custom widget that fixes issue in forms that prevents setting 
    fields as required - described here:
    https://github.com/collective/volto-form-block/issues/130
*/
import { Checkbox } from 'semantic-ui-react';
import { FormFieldWrapper } from '@plone/volto/components';

const RandomSuffixCheckboxWidget = (props) => {
  const { id, title, value, onChange, isDisabled, required, invalid } = props;
  const randomSuffixId = Math.random().toString(36).substr(2, 5);

  let attributes = {};
  if (required) {
    attributes.required = true;
    attributes['aria-required'] = 'true';
  }

  const isInvalid = invalid === true || invalid === 'true';
  if (isInvalid) {
    attributes['aria-invalid'] = true;
  }

  return (
    <FormFieldWrapper {...props} columns={1}>
      <div className="wrapper">
        <Checkbox
          id={`field-${id}-${randomSuffixId}`}
          name={`field-${id}-${randomSuffixId}`}
          checked={value || false}
          disabled={isDisabled}
          onChange={(event, { checked }) => {
            onChange(id, checked);
          }}
          aria-required={required ? 'true' : 'false'}
          label={
            <label htmlFor={`field-${id}-${randomSuffixId}`}>{title}</label>
          }
          {...attributes}
        />
      </div>
    </FormFieldWrapper>
  );
};

export default RandomSuffixCheckboxWidget;
